import { useCtrlShiftK } from '@hooks/useCtrlShiftK';
import { useMemo, useState } from 'react';

import type { EnvironmentService } from './application/EnvironmentService/EnvironmentService';
import {
  isLoggingLevel,
  LogLevelLoggingService,
} from '@application/LoggingService';

export const useBuildLoggingService = ({
  environmentService,
}: {
  environmentService: EnvironmentService;
}) => {
  const [loggingLevelFrom, setLoggingLevelFrom] = useState<
    'environment' | 'always-on'
  >('environment');

  const loggingLevelFromEnvironment =
    getLoggingLevelFromEnvironment(environmentService);

  const loggingService = useMemo(
    () =>
      new LogLevelLoggingService(
        loggingLevelFrom === 'environment'
          ? loggingLevelFromEnvironment
          : 'info',
      ),
    [loggingLevelFrom, loggingLevelFromEnvironment],
  );

  useCtrlShiftK(() => {
    setLoggingLevelFrom(
      loggingLevelFrom === 'always-on' ? 'environment' : 'always-on',
    );
  });

  return loggingService;
};

export const getLoggingLevelFromEnvironment = (
  environmentService: EnvironmentService,
) => {
  const loggingLevelFromEnv =
    environmentService.getPossiblyUndefined('PUBLIC_LOG_LEVEL');

  return loggingLevelFromEnv && isLoggingLevel(loggingLevelFromEnv)
    ? loggingLevelFromEnv
    : 'silent';
};
